/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// Review Component
import React, { PureComponent } from "react";

// Import Component
import Button from "../Button";
import { WithRatingStar } from "../Ratings";

const items = [
  {
    title: "chicken tika",
    count: 5,
    id: "1"
  },
  {
    title: "pizza",
    count: 4,
    id: "2"
  },
  {
    title: "pane pizza",
    count: 3,
    id: "3"
  },
  {
    title: "prompt service",
    count: 4,
    id: "4"
  }
];

export default class Review extends PureComponent {
  /* Other Render Functions */
  _renderTag(item) {
    return (
			<div className="tag col-md-5" key={item.id}>
				{item.title} {`(${item.count})`}
			</div>
		);
  }

  /* Render Functions */
  render() {
    return (
      <div className="col-md-12 p-0 mt-10 review-item">
        <div className="col-md-12 p-0 flex">
          <div className="col-md-10 p-0 _ai-self">
            <h3 className="margin-0">Customer Reviews</h3>
          </div>
          <div className="col-md-2 p-0">
            <Button
              variant={"review"}
              size="md"
              label={"Write Review"}
              iconName="edit"
            />
          </div>
        </div>
        <div className="col-md-12 p-0 flex-center rating-div">
          <div className="rate-content col-md-12 p-0 flex-center">
            <div className="rating-details">
              <WithRatingStar rating={4.7} />
            </div>
            <div className="totalrate _ai-self">4.7 out of 5</div>
          </div>
          <h5 className="margin-0">40 Customer Ratings</h5>
        </div>
        <div className="col-md-12 p-0">
          <div className="col-md-5 p-0 rate-star-div">
            <div className="col-md-12 p-0 mb-14">
              <div className="col-md-2 p-0 star-text">5 Stars</div>
              <div
                style={{
                  background: `linear-gradient(to right, #FFCC48 ${80}%, #ebebef ${20}%)`
                }}
                className="progressbar col-md-10 p-0"
              />
            </div>
            <div className="col-md-12 p-0 mb-14">
              <div className="col-md-2 p-0 star-text">4 Stars</div>
              <div
                style={{
                  background: `linear-gradient(to right, #FFCC48 ${70}%, #ebebef ${
                    100 - 70
                  }%)`
                }}
                className="progressbar col-md-10 p-0"
              />
            </div>
            <div className="col-md-12 p-0 mb-14">
              <div className="col-md-2 p-0 star-text">3 Stars</div>
              <div
                style={{
                  background: `linear-gradient(to right, #FFCC48 ${60}%, #ebebef ${
                    100 - 60
                  }%)`
                }}
                className="progressbar col-md-10 p-0"
              />
            </div>
            <div className="col-md-12 p-0 mb-14">
              <div className="col-md-2 p-0 star-text">2 Stars</div>
              <div
                style={{
                  background: `linear-gradient(to right, #FFCC48 ${55}%, #ebebef ${
                    100 - 55
                  }%)`
                }}
                className="progressbar col-md-10 p-0"
              />
            </div>
            <div className="col-md-12 p-0 last-item">
              <div className="col-md-2 p-0 star-text">1 Stars</div>
              <div
                style={{
                  background: `linear-gradient(to right, #FFCC48 ${50}%, #ebebef ${
                    100 - 50
                  }%)`
                }}
                className="progressbar col-md-10 p-0"
              />
            </div>
          </div>
          <div className="col-md-7 pl-32">
            <div className="col-md-12 p-0">
              <h5 className="margin-0">Read what people are talking about</h5>
            </div>
            <div className="col-md-12 p-0 items mt-20">
              {items.map((item) => this._renderTag(item))}
            </div>
          </div>
        </div>
        <div className="col-md-12 line-div" />
      </div>
    );
  }
}
